export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-address-book-760bd42d3e2d328fd0f45522336df62f.svg";